var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41602 9.27004V7.60337C5.41602 4.84504 6.24935 2.60337 10.416 2.60337C14.5827 2.60337 15.416 4.84504 15.416 7.60337V9.27004M10.416 16.3534C10.9685 16.3534 11.4985 16.1339 11.8892 15.7432C12.2799 15.3525 12.4993 14.8226 12.4993 14.27C12.4993 13.7175 12.2799 13.1876 11.8892 12.7969C11.4985 12.4062 10.9685 12.1867 10.416 12.1867C9.86348 12.1867 9.33358 12.4062 8.94288 12.7969C8.55218 13.1876 8.33268 13.7175 8.33268 14.27C8.33268 14.8226 8.55218 15.3525 8.94288 15.7432C9.33358 16.1339 9.86348 16.3534 10.416 16.3534Z",
    stroke: "#111111",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5826 19.27H6.24931C2.91597 19.27 2.08264 18.4367 2.08264 15.1034V13.4367C2.08264 10.1034 2.91597 9.27004 6.24931 9.27004H14.5826C17.916 9.27004 18.7493 10.1034 18.7493 13.4367V15.1034C18.7493 18.4367 17.916 19.27 14.5826 19.27Z",
    stroke: "#111111",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.4ef735ecd645829cc14657c6e1a45ee2.svg";
export { ForwardRef as ReactComponent };